import { useEffect, useState } from "react";

import { createCategoryMeasureScoreObj } from "../../utils/RecognitionProgramUtils";

import useKpiMeasureData from "../../../state/kpiMeasure/UseKpiMeasureData";
import useCategoryMeasureScoreData from "../../../state/categoryMeasureScore/UseCategoryMeasureScoreData";

import useRecognitionProgramData from "@usas/ui-web/state/recognitionProgram/UseRecognitionProgramData";

const UseKpiViewStaffRoleReport = (programLevel, categoryMeasure, isReadonly, onRedirect) => {
  const { kpiMeasureState, postKpiMeasure, putKpiMeasure, getKpiMeasure } = useKpiMeasureData();
  const { categoryMeasureScoreState, putCategoryMeasureScore } = useCategoryMeasureScoreData();
  const { recognitionProgramState, getCurrentProgramByProgramType } = useRecognitionProgramData();
  const [state, setState] = useState({ tryScoreOverrideRedirect: false, tryKpiRedirect: false });

  useEffect(() => {
    if (categoryMeasure && programLevel && kpiMeasureState.isArrayLoaded === false) {
      if (categoryMeasure.categoryMeasureScoreId > 0) {
        if (isReadonly === true) {
          getKpiMeasure(programLevel.programLevelInstanceId, categoryMeasure.categoryMeasureId, categoryMeasure.endpointUrl);
        } else if (categoryMeasure.scoreEntryOverride === true) {
          getKpiMeasure(programLevel.programLevelInstanceId, categoryMeasure.categoryMeasureId, categoryMeasure.endpointUrl);
        } else {
          putKpiMeasure(programLevel.programLevelInstanceId, categoryMeasure.categoryMeasureId, categoryMeasure.categoryMeasureScoreId, categoryMeasure.endpointUrl);
        }
      } else if (isReadonly !== true) {
        postKpiMeasure(programLevel.programLevelInstanceId, categoryMeasure.categoryMeasureId, categoryMeasure.endpointUrl);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryMeasure, programLevel, isReadonly, kpiMeasureState.isArrayLoaded]);

  useEffect(() => {
    if (kpiMeasureState.isArrayLoaded === true && kpiMeasureState.isArrayLoading === false) {
      if (state.tryKpiRedirect === true) {
        onRedirect(true);
      } else {
        getCurrentProgramByProgramType(recognitionProgramState.orgUnitId, recognitionProgramState.programTypeId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryKpiRedirect, kpiMeasureState]);

  useEffect(() => {
    if (state.tryScoreOverrideRedirect === true && categoryMeasureScoreState.isSaving === false
      && categoryMeasureScoreState.isSaved === true) {
      onRedirect(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tryScoreOverrideRedirect, categoryMeasureScoreState]);

  function submitFormCallback(formState) {
    if (formState.scoreEntryOverride === true) {
      putCategoryMeasureScore(categoryMeasure.categoryMeasureScoreId,
        createCategoryMeasureScoreObj(categoryMeasure, programLevel, 'Submitted', formState.score, formState.scoreEntryOverride));

      setState({ ...state, tryScoreOverrideRedirect: true });
    } else {
      putKpiMeasure(programLevel.programLevelInstanceId, categoryMeasure.categoryMeasureId, categoryMeasure.categoryMeasureScoreId, categoryMeasure.endpointUrl);

      setState({ ...state, tryKpiRedirect: true });
    }
  };

  return {
    isEdit: categoryMeasure.categoryMeasureScoreId > 0,
    isSaving: categoryMeasureScoreState.isSaving,
    kpiMeasureState,
    recognitionProgramState,
    submitFormCallback
  };
};

export default UseKpiViewStaffRoleReport;